import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getUserAdvancedStore from "../../../../stores/user-store/advanced-store";

const KhattabatUserPager = withLiteObserverAndTheme(() => {
  const { userIDs, currentIndex, goToPrevUser, goToNextUser } =
    getUserAdvancedStore();

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="flex-end"
    >
      <IconButton
        aria-label={i18n.get("KHATTABAT_PREVIOUS")}
        onClick={goToPrevUser}
      >
        <ChevronLeftIcon />
      </IconButton>
      <Typography>{`${currentIndex.get() + 1} / ${userIDs.get().length}`}</Typography>
      <IconButton
        aria-label={i18n.get("KHATTABAT_NEXT")}
        onClick={goToNextUser}
      >
        <ChevronRightIcon />
      </IconButton>
    </Stack>
  );
});

export default KhattabatUserPager;
